import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '@app/services/authentication.service';
import { AuthorizationService } from '@app/services/authorization.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authenticationService.ensureSession().pipe(
      map(isAuthenticated => {
        if (!isAuthenticated) {
          return this.router.parseUrl('/login');
        }
        return this.authorizationService.isAdmin()
          ? true
          : this.router.parseUrl('/forbidden');
      })
    );
  }

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }
}
